import type { AppState } from "Data/Redux/Reducers";
import { asyncThunkCreator, buildCreateSlice, createAsyncThunk as createAsyncThunkBase } from "@reduxjs/toolkit";

export const createAppSlice = buildCreateSlice({
	creators: { asyncThunk: asyncThunkCreator }
});

export const createAsyncThunk = createAsyncThunkBase.withTypes<{ state: AppState }>();
